module.exports = __webpack_public_path__ + "img/SpecialChildrenXMasParty_2014.85244bd8.jpg";